/**
 * Используются для рантайм проверок вызова модульных селекторов во внешних сторах,
 * чтобы уведомлять о недопустимости таких вызовов, т.к. вне модульных
 * сторов нет подписки на модульные сторы - селекторы будут работать некорректно.
 */

let hasActiveTracker = false;
const scopeStack: Symbol[] = [];
const selectorCalls = new Set<Symbol>();

/**
 * Сообщает о вызове модульных селекторов
 * @example
 * ```ts
 * const selectorResult = trackSelectorCall(
 *     () => externalSelector(...selectorArgs),
 *     () => reportModulesSelectorUsage()
 * );
 * ```
 * @param runSelector функция, внутри которой вызывается внешний селектор
 * @param onModulesSelectorCall функция, которая вызовется в случае, если внутри runSelector вызван модульный селектор
 * @returns результат вызова runSelector
 */
export function trackSelectorCall<Result>(runSelector: () => Result, onModulesSelectorCall: () => void) {
    const currentScopeId = Symbol();
    scopeStack.push(currentScopeId);
    hasActiveTracker = true;

    const result = runSelector();

    try {
        if (selectorCalls.has(currentScopeId)) {
            onModulesSelectorCall();
        }
    } finally {
        selectorCalls.delete(currentScopeId);
        scopeStack.pop();
        hasActiveTracker = scopeStack.length > 0;
    }

    return result;
}

/**
 * Сообщает о вызове модульного селектора
 */
export function triggerSelectorCall() {
    if (!hasActiveTracker) {
        return;
    }

    const currentScopeId = scopeStack[scopeStack.length - 1];

    if (currentScopeId) {
        selectorCalls.add(currentScopeId);
    }
}
